import axios from '../http'

function query(data) {
    return axios.post('/event/raceBoard/query', data);
}


function get(id) {
    return axios.get('/event/raceBoard/get?id=' + id);
}

export default {
    query,
    get
}